export enum STRING_BOOLEAN {
  true = 'true',
  false = 'false',
}

export const PROFILE_SUB_ROUTES = [
  "/address-change",
  "/contact-email",
  "/contact-address",
  "/contact-phone",
  "/ratings",
  "/suspensions",
  "/trades",
  "/capabilities",
  "/tickets",
  "/usage",
  "/security-question",
];

const TELEPHONE_BOARD_SUB_ROUTES = [
  "/telephone-board-slips/:board",
  "/telephone-plugin/:board/:shift/:date",
  "/telephone-plugin/:board",
];

const DOA_FORECAST_SUB_ROUTES = [
  "/doa-forecast-stats/:dispatch/:date",
  "/doa-forecast/doa-admin/:dispatch/:date/stats",
];

/**
 * Map a list of subroutes to a shared destination
 */
const setDestinations = (subroutes: string[], dest: string): { [key: string]: string } => {
  return subroutes.reduce((acc, val) => { acc[val] = dest; return acc; }, {} as Record<string, string>);
}

/** 
* Map destinations to back destinations
* Useful to determine whether a back button should be showing and in determining
* which default location to go back to if there is no history in the stack
*/
export const subdestinationMap: { [key: string]: string } = {
  ...setDestinations(PROFILE_SUB_ROUTES, "/my-profile"),
  "/usage-results/:startDate/:endDate": "/usage",
  "/dispatch-history-results/:startDate/:endDate": "/dispatch-history",
  "/union-board-slips/:board": "/union-board/:board",
  ...setDestinations(TELEPHONE_BOARD_SUB_ROUTES, "/telephone-board/:board"),
  "/doa": "/work-info/vancouver/all",
  "/payroll-history-results/:startDate/:endDate": "/payroll-history",
  ...setDestinations(DOA_FORECAST_SUB_ROUTES, "/doa-forecast"),
  "/availability-administration-employee/:dispatch/:date": "/availability-administration-shifts",
  "/gang-way-report-results/:date/:shift": "/gang-way-report",
  "/union-audit-report-results/:date/:reportDispatchType": "/union-audit-report",
  "/union-audit-report-results/:date/:reportDispatchType/details": "/union-audit-report-results/:date/:reportDispatchType",
  "/casual-audit-report-results/:date/:reportDispatchType": "/casual-audit-report",
  "/casual-audit-report-results/:date/:reportDispatchType/details": "/casual-audit-report-results/:date/:reportDispatchType",
  "/dispatch-availability-list-report-results/:date/:shift/:job": "/dispatch-availability-list-report",
  "/slip-preview-slip/:orderDetailId": "/",
  "/slip-preview-slip/groupId/:groupId": "/",
  "/dr-plugin-availability": "/work-info/vancouver/all",
  "/verify-contact-email/:formType": "/online-applications",
  "/paid-medical-leave-request": "/online-applications",
  "/paid-personal-leave-request": "/online-applications"
}

/** 
* Map destinations to breadcrumbs destinations
* Useful to determine whether a breadcrumbs menu should be showing and in determining
* which default location to go back to if there is no history in the stack
*/
export const breadcrumbsSubdestinationMap: { [key: string]: string } = {
  "/union-audit-report-results/:date/:reportDispatchType/details": "/union-audit-report-results-details",
  "/casual-audit-report-results/:date/:reportDispatchType/details": "/casual-audit-report-results-details",
}

export const breadcrumbsSubdestinationLabelMap: { [key: string]: string[] } = {
  "/union-audit-report-results-details": ["Report Parameters", "Summary"],
  "/casual-audit-report-results-details": ["Report Parameters", "Summary"]
}

export enum AuthenticationMethod {
  smb = "SMB",
  ivr = "IVR"
}
